// extracted by mini-css-extract-plugin
module.exports = {"company":"company__ctMJ0","company-value":"company-value__2yROk"};